(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/selfservice-cart/assets/javascripts/reducers/root-reducer.js') >= 0) return;  svs.modules.push('/components/components/selfservice-cart/assets/javascripts/reducers/root-reducer.js');
"use strict";


const _RTK = RTK,
  combineReducers = _RTK.combineReducers;
const _svs$components$selfs = svs.components.selfserviceCart.reducers,
  itemsReducer = _svs$components$selfs.itemsReducer,
  cartOpenReducer = _svs$components$selfs.cartOpenReducer;
const rootReducer = combineReducers({
  items: itemsReducer,
  cartOpen: cartOpenReducer
});
setGlobal('svs.components.selfserviceCart.reducers.rootReducer', rootReducer);

 })(window);